import type { ComponentProps, ElementType } from 'react';

import { twMerge } from 'tailwind-merge';

type AdditionalDataModalInputTypeProps<T extends ElementType> = {
  header: string;
  description: string;
  as: T;
} & ComponentProps<T>;

const AdditionalDataModalInput = <T extends ElementType>({
  header,
  as,
  description,
  ...props
}: AdditionalDataModalInputTypeProps<T>) => {
  const InputComponent = as;

  return (
    <div className="grid my-4 mx-2">
      <label
        className={twMerge(
          'text-slate-900 font-bold capitalize text-lg row-span-1 md:text-xl dark:text-white',
          props?.required &&
            "after:content-['*'] after:text-red after:ml-1 whitespace-nowrap",
        )}
      >
        {header}
      </label>
      <span className="text-sm text-slate-400 dark:text-slate-200 mb-2  ">
        {description}
      </span>
      <div>
        <InputComponent {...props} additionalErrorClasses="absolute" />
      </div>
    </div>
  );
};

export default AdditionalDataModalInput;
